export default __webpack_public_path__ + "static/50-1a6b234248a22fa9e3ecab933f85a9cb.png";